module.exports = __webpack_public_path__ + "media/images/pc/specials/common/event_detail_photo-6ca9122b0d1435a3ff4cc490835b07f2.jpg";